import { combineReducers } from 'redux';

import * as types from 'modules/cameras/actionTypes';
import type { FetchUnlinkedHardwareSuccessAction, UnlinkedHardware } from 'modules/cameras/types';
import createSearchReducers from 'modules/global/reducers/simpleSearchReducer';
import { createEntityAdapter, createReducer } from 'utils/ReduxUtils';
import type { EntitySlice } from 'utils/ReduxUtils';

const hardwareAdapter = createEntityAdapter<UnlinkedHardware>({ selectId: ({ id }) => id });

const setAllHardware = (state: EntitySlice<UnlinkedHardware>, { payload }: FetchUnlinkedHardwareSuccessAction) =>
  hardwareAdapter.setAll(state, payload.content);

export default combineReducers({
  data: createReducer(hardwareAdapter.getInitialState(), {
    [types.FETCH_CAMERAS_UNLINKED_HARDWARE_SUCCESS]: setAllHardware,
  }),
  ui: createSearchReducers(types.FETCH_CAMERAS_UNLINKED_HARDWARE),
});
